import _ from 'lodash';

import tagService from 'services/tag-service';

const defaultTag = {
  id: null,
  name: "",
  clientId: null,
  type: null,
};

const state = {
  tag: _.cloneDeep(defaultTag),
  tags: []
};


const actions = {
  async getForForm({ commit }, id) {
    let tag = id ? await tagService.getForForm(id) : _.cloneDeep(defaultTag);

    commit('get-for-form', tag);
  },

  async getTagSelectList({ commit }, { clientId, isForFilter }) {
    let tags = await tagService.getAsSelectListItems(clientId, isForFilter);

    tags = tags.map(c => {
      return {
        text: c.text,
        label: c.text,
        value: c.value
      }
    }).sort((a, b) => a.label.localeCompare(b.label));

    commit('get-select-list', tags);
  },

  async save({ state, commit }) {
    let tag = state.tag.id ? await tagService.update(state.tag) : await tagService.create(state.tag);

    commit('save', tag);
  },

  async delete({ commit }, id) {
    await tagService.delete(id);

    commit('clear');
  },

  clear({ commit }) {
    commit('clear');
  }
};

const mutations = {
  'clear'(state) {
    state.tag = _.cloneDeep(defaultTag);
  },

  'get-for-form'(state, tag) {
    state.tag = tag;
  },

  'get-select-list'(state, tags) {
    state.tags = tags;
  },

  'save'(state, tag) {
    state.tag = tag;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
}